export default {
  noDataToCompare: 'Nie je vybratá žiadna zákazka na porovnanie',
};
